<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px'}"></ngx-loading>
<h2 mat-dialog-title class="bgDialogHeader text-center">
    Change Password
    <div class="pull-right">
        <a class="boxclose" (click)="onNoClick()"></a>
    </div>
</h2>
<form [formGroup]="changePasswordForm">
    <div class="col-12">
        <mat-form-field class="full-width">
            <input type="password" matInput class="form-control" required placeholder="Old Password"
                formControlName="oldPassword">
        </mat-form-field>
        <div *ngIf="changePasswordForm.controls.oldPassword.touched && changePasswordForm.controls.oldPassword.errors"
            class="error">
            <div *ngIf="changePasswordForm.controls.oldPassword.errors.required">
                <div class="alert custom-alert-danger" role="alert">
                    <span class="sr-only">Error:</span>
                    Old Password is required
                </div>
            </div>
        </div>
        <div *ngIf="msgType === 0" class="error">
            <div class="alert custom-alert-danger" role="alert">
                <span class="sr-only">Error:</span>
                Incorrect Old Password
            </div>
        </div>
    </div>
    <div class="col-12">
        <mat-form-field class="full-width">
            <input type="password" matInput class="form-control" required placeholder="New Password"
                formControlName="password" [(ngModel)]="password">
        </mat-form-field>
        <div *ngIf="changePasswordForm.controls.password.touched && changePasswordForm.controls.password.errors"
            class="error">
            <div *ngIf="changePasswordForm.controls.password.errors.required">
                <div class="alert custom-alert-danger" role="alert">
                    <span class="sr-only">Error:</span>
                    New Password is required
                </div>
            </div>
            <div *ngIf="changePasswordForm.controls.password.errors.pattern">
                <div class="alert custom-alert-danger" role="alert">
                    <span class="sr-only">Error:</span>
                    Password must be of 8 character long having
                    at least one upper case ,one lower case ,one digit,one special character from (#?!@$%^&*-.).
                </div>
            </div>
        </div>
        <div *ngIf="msgType === 2" class="error">
            <div class="alert custom-alert-danger" role="alert">
                <span class="sr-only">Error:</span>
                your new password is same as your old password
            </div>
        </div>
    </div>
    <div class="col-12">
        <mat-form-field class="full-width">
            <input type="password" matInput class="form-control" required placeholder="Confirm Password"
                formControlName="confPassword" [compareEqual]="password">
        </mat-form-field>
        <div *ngIf="changePasswordForm.controls.confPassword.touched && changePasswordForm.controls.confPassword.errors"
            class="error">
            <div *ngIf="changePasswordForm.controls.confPassword.errors.required">
                <div class="alert custom-alert-danger" role="alert">
                    <span class="sr-only">Error:</span>
                    Confirm Password is required
                </div>
            </div>
            <div
                *ngIf="changePasswordForm.controls.confPassword.errors.compareEqual && !changePasswordForm.controls.confPassword.errors.required">
                <div class="alert custom-alert-danger" role="alert">
                    <span class="sr-only">Error:</span>
                    Password Do Not Match.
                </div>
            </div>
        </div>
    </div>
</form>

<div class="col-md-12 border-top" align="end" mat-dialog-actions>
    <button class="btn btn-semi-round bgBlue pull-right" (click)="changePassword()"> Change Password </button>
</div>